export default "__VITE_ASSET__68c725ea__"